"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResolutionAndFlag = exports.getApprovalSheetResolutionsTableParticipants = exports.mapParticipantsDTOToIdTitle = exports.mapIdTitleToParticipantsDTO = void 0;
exports.mapIdTitleToParticipantsDTO = function (participants, parallel, oldParticipants) {
    return participants.map(function (participant, participantIndex) {
        var userId = participant.id, fio = participant.title;
        var index = parallel ? 1 : participantIndex + 1;
        var oldParticipant = oldParticipants === null || oldParticipants === void 0 ? void 0 : oldParticipants.find(function (oldParticipant) { return oldParticipant.userId === userId; });
        return {
            id: oldParticipant === null || oldParticipant === void 0 ? void 0 : oldParticipant.id,
            index: index,
            userId: userId,
            fio: fio,
            resolutionDate: oldParticipant === null || oldParticipant === void 0 ? void 0 : oldParticipant.resolutionDate,
            resolutionType: oldParticipant === null || oldParticipant === void 0 ? void 0 : oldParticipant.resolutionType,
        };
    });
};
exports.mapParticipantsDTOToIdTitle = function (participants) {
    return participants.map(function (participant, index) {
        var fio = participant.fio, userId = participant.userId;
        return {
            id: userId,
            title: fio,
        };
    });
};
exports.getApprovalSheetResolutionsTableParticipants = function (groups, isActiveSheetStatus) {
    return groups.reduce(function (currentParticipants, group) {
        var groupParticipants = group.participants, groupType = group.groupType, parallel = group.parallel, isActiveGroup = group.isActiveGroup, isAfterActiveGroup = group.isAfterActiveGroup;
        var isActiveParticipant = isActiveGroup && isActiveSheetStatus;
        var participantsForTable;
        if (parallel) {
            // для параллельной группы все просто: согласовывать могут все участники активной группы
            participantsForTable = groupParticipants.map(function (participant) {
                return __assign(__assign({}, participant), { groupType: groupType,
                    isActiveParticipant: isActiveParticipant, isParallel: parallel, isAfterActiveGroup: isAfterActiveGroup });
            });
        }
        else {
            // последовательная группа: согласовывать может человек, следующий за последним согласовавшим
            var lastResolvedParticipant = void 0; // последний согласовавший в группе
            var activeParticipant_1; // активный участник
            if (isActiveParticipant) {
                var groupParticipantsLength = groupParticipants.length;
                for (var index = 0; index < groupParticipantsLength; index++) {
                    var currentParticipant = groupParticipants[index];
                    if (currentParticipant.resolutionDate) {
                        lastResolvedParticipant = currentParticipant;
                    }
                    else {
                        // если у текущего участника нет подписи, то выходим, т.к. считаем, что подписи должны идти последовательно
                        activeParticipant_1 = currentParticipant;
                        break;
                    }
                }
            }
            participantsForTable = groupParticipants.map(function (participant) {
                isActiveParticipant = !!activeParticipant_1 && participant.id === activeParticipant_1.id;
                return __assign(__assign({}, participant), { groupType: groupType, isActiveParticipant: isActiveParticipant, isParallel: parallel });
            });
        }
        currentParticipants.push.apply(currentParticipants, participantsForTable);
        return currentParticipants;
    }, []);
};
exports.getResolutionAndFlag = function (userId, editGroup) {
    var _a;
    var resolution = ((_a = editGroup === null || editGroup === void 0 ? void 0 : editGroup.participants.find(function (participant) { return participant.userId === userId; })) === null || _a === void 0 ? void 0 : _a.resolutionType) || undefined;
    var hasResolution = resolution !== undefined;
    return [resolution, hasResolution];
};
